export default __webpack_public_path__ + "static/media/dessert02.486a63e9.png";